import { render } from "./copyPortion.vue?vue&type=template&id=9963b66a"
import script from "./copyPortion.vue?vue&type=script&lang=js"
export * from "./copyPortion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__